// Blog Section Slider 
var swiper = new Swiper(".blogSlider", {
  slidesPerView:3,
  pagination: {
    el: ".swiper-pagination-blog",
    clickable: true,
  },
   navigation: {
    nextEl: ".blog_slider-next",
    prevEl: ".blog_slider-prev",
  },
  breakpoints: {
    1025: {
      slidesPerView:3,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
    500: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    320: {
      slidesPerView: 1,
  spaceBetween: 10,
    },
  },
});

  // collection list Section (our latest pick)
  var swiper = new Swiper(".itg-collectionSwiperMain", {
    slidesPerView: 2,
    slidesPerColumn: 2,
    slidesPerGroup :2,
    speed: 700,
    grid: {
      rows: 2,
      fill: "row"
    },
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      769: {
          spaceBetween: 20,
      },
    },
  });


// Testimonial Section Slider
 var swiper = new Swiper(".testimonialSlider", {
      spaceBetween: 20,
      centeredSlides: true,
      loop:true,
      grabCursor: true,
      pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
      navigation: {
      // nextEl: ".blog_slider-next",
      // prevEl: ".blog_slider-prev",
    },
      breakpoints: {
      1025: {
        slidesPerView:1.9,
      },
      500: {
        slidesPerView: 1.2,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
  },
});

 // Collection Tab Slider
  var swiper = new Swiper('.swiper-collection', {
      direction: 'horizontal',
       loop:true,
        grabCursor: true,
      spaceBetween: 20,
      // Navigation arrows
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      breakpoints: {
          320: {
              slidesPerView: 1,
          },
          480: {
              slidesPerView: 2,
          },
          767: {
              slidesPerView: 3,
          },
          1024: {
              slidesPerView: 4,
          }
      }
  });

// collection list section js start
$(document).ready(function (){
  $('.collection_tab_head .collection_title a').click(function (e) {
    e.preventDefault();
    $('.collection_tab_head .collection_title').removeClass("active");
    $(this).parent().addClass("active");
    var HeadtabToShow = $(this).parent().attr("data-tab");
    $('.all_collection_products .single_collection_products').each(function (index,value) {
      var prodCollectionTab = $(value).attr("data-tab");
      if(HeadtabToShow == prodCollectionTab ){
        $('.all_collection_products .single_collection_products').removeClass("active");
        $(value).addClass("active");
      }
    });
  });  
});
 
      

$(document).ready(function (){
  // Multi Language Footer 
  const LangChange = ()=> {
    $('.multi-selection .langshow').text($('#LocaleSelector-toolbar').attr('value'));
  }
  LangChange();
  $(document).on('change','#LangList-toolbar', LangChange);
  
  // Menu contains 'sale' > red color
     $('.site-nav .site-nav__link, .site-nav__dropdown > li > .site-nav__dropdown-link, .mobile-nav__item > .mobile-nav__link, .mobile-nav__child-item > .mobile-nav__link').each(function (){
      if($(this).text().toLowerCase().includes('sale')) {
          $(this).css('color', 'red').addClass('red');
      }
    });

   if($('.header-wrapper .site-nav > .site-nav__item').find('.site-nav__details').attr('open') !== undefined) {
          $('.itg-menuBackground').addClass('itgNone');
      } else {
        $('.itg-menuBackground').removeClass('itgNone');
      }

  if($('.site-nav__details').attr('data-hover') == 'false') {
    $(document).on('click','.header-wrapper .site-nav > .site-nav__item',function (){
      setTimeout(()=>{
      const eleHeight = $(this).find('.site-nav__dropdown').outerHeight();
        if($(this).find('.site-nav__details').attr('open') !== undefined) {
          $('.itg-menuBackground').addClass('itgNone');
          $('.itgNone').css('min-height',eleHeight);
        } else {
          $('.itg-menuBackground').removeClass('itgNone');
        }
      },0)
    });
  } else {
   $(document).on('mouseenter mouseleave','.header-wrapper .site-nav > .site-nav__item',function (){
      setTimeout(()=>{
      const eleHeight = $(this).find('.site-nav__dropdown').outerHeight();
        if($(this).find('.site-nav__details').attr('open') !== undefined) {
          $('.itg-menuBackground').addClass('itgNone');
          $('.itgNone').css('min-height',eleHeight);
        } else {
          $('.itg-menuBackground').removeClass('itgNone');
        }
      },0)
    });
  }

  
})
$(document).ready(function (){

// ----------------------  collection page filter (On sale) ----------------------
  $(document).on('click','.collection-filter__item--siderBar button',function (){
    
    if($(this).hasClass('itgShow')){
      $('.grid__item--sidebar').hide();
        $('.grid__item--content').addClass('itgfullwidth');
      $(this).removeClass('itgShow');
    } else {
       $('.grid__item--sidebar').show();
        $('.grid__item--content').removeClass('itgfullwidth');
        
      $(this).addClass('itgShow');
    }
  });

  // Collection page filter 'More'
   $(document).on('click','#CollectionSidebar .itgMoreText',function (){
     $(this).siblings('.tag-list').removeClass('more_filter5').addClass('more_filter10');
     $(this).hide().siblings('.itgLessText').css('display','inline-block');
   });
    // Collection page filter 'Less'
   $(document).on('click','#CollectionSidebar .itgLessText',function (){
     $(this).siblings('.tag-list').removeClass('more_filter10').addClass('more_filter5');
     $(this).css('display','none').siblings('.itgMoreText').show();
     $(this).siblings('.tag-list').scrollTop(0);
   });

  
 // Hotspot section functionality
  $(document).on('click','.hotspots .hotspots__buttons .hotspot__button',function (){
    let hotspot_databtn = $(this).attr('data-button');
    $(`.hotspot-content__block[data-hotspot-block="${hotspot_databtn}"]`).scrollTop($(`.hotspot-content__block[data-hotspot-block="${hotspot_databtn}"]`).scrollTop()-20)
  });
 


  // ============================== Product compare functionality start ==============================
  // click on product grid swap icon

  $(document).on('click','.hotspots_swapIcon',function (){
    let productHandle = $(this).parents('.grid__item').attr('data-product-handle');
    let compareList =  JSON.parse(localStorage.getItem('compareList')) || [];  
    if(!compareList.includes(productHandle)){
       if (compareList.length < 4) {
         compareList.push(productHandle);
         $(this).addClass('itg-swap');
       } else {        
            $('.compareNotify').show();
            // setTimeout(() => $('.compareNotify').hide(), 5000);
             function hideBox () {
               setTimeout(() => $('.compareNotify').hide(), 10000);
             }
             function debounce_leading(func, timeout) {
                let timer;
                return (...args) => {
                    if (!timer) {
                      func.apply(this, args);
                    }
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        timer = undefined;
                    }, timeout);
                };
            }
          const debouncedFunction = debounce_leading(hideBox,10000);
          debouncedFunction();
       }
    } else {
       $(this).removeClass('itg-swap');
       compareList = compareList.filter(item => item != productHandle);
    }
    localStorage.setItem('compareList',JSON.stringify(compareList));
    if (compareList.length > 1) {
      $('.Product_compare').addClass('itgShow').attr('data-text',compareList.length);
    } else {
      $('.Product_compare').removeClass('itgShow');
    }
  });

    // When compare popUp show > Swap icon with count  hide
   const popUpAvailable = () => $('.compare_popup').length > 0 ? $('.Product_compare').addClass('itgShow') : $('.Product_compare').removeClass('itgFlex');
   let compareLists =  JSON.parse(localStorage.getItem('compareList')) || [];
   if (compareLists.length > 1) {
      $('.Product_compare').addClass('itgShow').attr('data-text',compareLists.length);
    } else {
      $('.Product_compare').removeClass('itgShow');
    }
    // Swap icon with count click
    $(document).on('click','.Product_compare',function (){
    popUpAvailable();
      $(this).removeClass('itgShow');
      let comparePopUp = $('.compare_popup .compare_popupCol');
      $('.compare_popup').addClass('itgFlex');
      let compareList =  JSON.parse(localStorage.getItem('compareList'));
         compareList.forEach((productHandle)=>{
         fetch(`/products/${productHandle}.json`)
         .then(response => response.json())
         .then(data => {
            let { product } = data;
            let productHTML = `
              <div class="comparison-product" data-compare-product="${product.handle}">
                <div class="compProductCancel">
                   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                </div>
                <img src="${product.images[0].src}&width=360" alt="${product.title}" />
                <div class="compareContent">
                  <a href="/products/${product.handle}">
                  <h3>${product.title}</h3>
                  </a>
                  <div class="compExtra">
                   <div class="proComp"><p>Price</p><p class="secondComp">${product.variants[0].price}</p></div>
                    <div class="proComp"><p>Vendor</p><p class="secondComp"> ${product.vendor}</p></div>
            `;
             if(product.options && product.options.length) {
               product.options.forEach(option => {
                 productHTML+=`
                   <div class="proComp"><p>${option.name}</p><p class="secondComp"> ${option.values.join(',  ')}</p></div>
               `})
             }
              productHTML += `
                </div>
              </div>
            </div>
          `;
            comparePopUp.append(productHTML);
          });
        });
      });
    const hideCompareMain = () => {
      $('.compare_popup').removeClass('itgFlex');
      $('.compare_popupCol').text('');
    }
    // single product remove (compare product) 
    $(document).on('click','.compProductCancel',function (){
      let compareList =  JSON.parse(localStorage.getItem('compareList'));
      let compareProHandle = $(this).parents('.comparison-product').data('compare-product');
      compareList = compareList.filter(item => item != compareProHandle); 
      localStorage.setItem('compareList',JSON.stringify(compareList));
      $(this).parents('.comparison-product').remove();
       $(`.grid__item[data-product-handle="${compareProHandle}"]`).find('.hotspots_swapIcon').removeClass('itg-swap');
      if(!(compareList.length > 1)){
       hideCompareMain();
      }  
      $('.Product_compare').attr('data-text',compareList.length);
     
    })
    // more than 4 Notification cancel functionality
    $(document).on('click','.compareNotify .cancelNotify', function (){
      $(this).parents('.compareNotify').hide();
    })

    // Compare popUp 'cancel' button and 'cancel All' button
    $(document).on('click', '.compare_popup .compare_clearAll, .compare_popup .cancelCompare_popup', function() {
      const $popup = $(this).parents('.compare_popup');
      $popup.removeClass('itgFlex').find('.compare_popupCol').text('');
      
      // Compare popUp 'cancel All' button
      if ($(this).hasClass('compare_clearAll')) {
        localStorage.removeItem('compareList');
        $('.hotspots_swapIcon').removeClass('itg-swap');
      } else {
        $('.Product_compare').addClass('itgShow');
      }
    });
  // Background on swap icon
      compareLists.forEach((productHandle)=>{
      console.log( $(`.grid__item[data-product-handle="${productHandle}"]`).find('.hotspots_swapIcon'))
      $(`.grid__item[data-product-handle="${productHandle}"]`).find('.hotspots_swapIcon').addClass('itg-swap');
    })
  // ============================== Product compare functionality end ==============================

    // Go to top functionality
    $(document).on('click','.backToTop',function (){
     $('html, body').animate({ scrollTop: 0 }, 'slow');
    });
   
      const backToTop = () => $(window).scrollTop() > 400 ? $('.backToTop').css('display','flex') : $('.backToTop').css('display','none');
      backToTop();
      $(window).on('scroll', backToTop);
  
    // FAQ collapsible 'Expand All' button click
      $(document).on('click','.itgExpand',function (){
 
        if($(this).hasClass('expand')){
          $(this).text('Collapse All').removeClass('expand'); 
          expandAndCollapseFnc(true);  
        } else {   
          $(this).text('Expand All').addClass('expand');
          expandAndCollapseFnc(false);   
        }
        
      });

  function expandAndCollapseFnc(temp) {
     $('.itg-collapsible-Main .itg-collapsible .collapsible-content').each(function (index,elem) {
            if( !($(elem).hasClass("is-open")) && temp )
              $(elem).parents(".itg-collapsible").find(".collapsible-trigger").trigger('click');     
            if( $(elem).hasClass("is-open") && !temp )
              $(elem).parents(".itg-collapsible").find(".collapsible-trigger").trigger('click');
      });
  }

       
  
});


// Product page section which doesn't have content
document.querySelectorAll('.index-section').forEach(function (el) {
    if (!el.innerHTML.trim()) {  
        el.style.margin = '0';
    }
});


// On click on navigation go to specific section(eg.Affiliate and link,How does Pinklitt work? And How We Pick It)
document.body.addEventListener('click', (e) => {
  if (e.target.tagName.toLowerCase() === 'a') {
    sessionStorage.setItem('User href', e.target.getAttribute('href'));
    sessionStorage.setItem('Current text', e.target.innerText);
  }
  if (e.target.tagName.toLowerCase() === 'summary') {
    sessionStorage.setItem('User href', e.target.getAttribute('data-link'));
    sessionStorage.setItem('Current text', e.target.innerText);
  }
});

let prevHref =  sessionStorage.getItem('User href');
let prevText =   sessionStorage.getItem('Current text');
let currentUrl = window.location.href;
if(currentUrl.includes(prevHref) && document.referrer ){
   console.log('prevText.toLowerCase:-'+prevText.toLowerCase());
  if(prevText.toLowerCase().includes('about')) {
     const weare = document.getElementById('itg_who-we-are');
     window.scrollTo({ top: (weare.offsetTop - 200), behavior: 'smooth' })
  }else if(prevText.toLowerCase().includes('affiliate')) {
    const affiliateElement = document.getElementById('affiliate');
    window.scrollTo({ top: (affiliateElement.offsetTop - 20), behavior: 'smooth' })
    setTimeout(() => affiliateElement.click(), 700);
  }else if(prevText.toLowerCase().includes('pick')) {
    const pickIt = document.getElementById('itg_pick-it');
    window.scrollTo({ top: (pickIt.offsetTop - 240), behavior: 'smooth' })
  } else if(prevText.toLowerCase().includes('work')) {
     const pinklittWork = document.getElementById('itg_pinklitt-work');
     window.scrollTo({ top: (pinklittWork.offsetTop - 240), behavior: 'smooth' })
  }else if(prevText.toLowerCase().includes('pinklitt')){
     const pinklittlabel = document.getElementById('itg_environmental-social');
     window.scrollTo({ top: (pinklittlabel.offsetTop - 180), behavior: 'smooth' })
  }
}

// Brand directory sort functionality Start

document.addEventListener('DOMContentLoaded', () => { 
  
  const urlParams = new URLSearchParams(window.location.search);
  
  const updateListClasses = () => {
    const sortBy_list = document.querySelectorAll('.sortBy_list li');
    sortBy_list.forEach((li) => {
      const targetValue = li.innerText.trim();
      const matchingElement = document.querySelector(`.brands-box[data-sort="${targetValue}"]`);
      if (!matchingElement) {
        li.classList.add('no_match'); // Add class if no match
      } else {
        li.classList.remove('no_match'); // Remove class if match exists
      }
    });
  }; 
  
  updateListClasses();

  const brandScroll = (e) => {

    // const sortBy_listScroll = document.querySelectorAll(`.brands-box[data-sort="${e.target.innerText}"]`);

    if(urlParams.has('custom-label')){
      const sortBy_listScroll = document.querySelectorAll(`.brands-box[data-sort="${e.target.innerText}"]`);
      let sortByArray = Array.from(sortBy_listScroll);
      const newSortBy_listScroll = sortByArray.filter((singleBrand) => singleBrand.classList.contains("showBrand")) ;
      if (newSortBy_listScroll[0]) {
        window.scrollTo({ top: (newSortBy_listScroll[0].offsetTop - 20), behavior: 'smooth' });
      } 
    }else{
      const sortBy_listScroll = document.querySelector(`.brands-box[data-sort="${e.target.innerText}"]`);
      if (sortBy_listScroll) {
        window.scrollTo({ top: (sortBy_listScroll.offsetTop - 20), behavior: 'smooth' });
      } 
    }
    
    // if (sortBy_listScroll) {
    //   window.scrollTo({ top: (sortBy_listScroll.offsetTop - 20), behavior: 'smooth' });
    // } 
    updateListClasses(); 
  };

  
  // Attach the event listener
  let sortBy_list = document.querySelectorAll('.sortBy_list li');
  sortBy_list.forEach((li) => {
    li.addEventListener('click', brandScroll);
  });
  
  // Brand directory sort functionality End



 let brandLabel = "" ;
  
  if (urlParams.has('custom-label')) {


      brandLabel = urlParams.get('custom-label') ;
    
      document.querySelector(".background-media-text__inner p.section_title").innerHTML = brandLabel ;
  
      document.querySelectorAll(".brands-grid .brands-box").forEach(function (elem) {
  
        let data_Labels = elem.getAttribute("data-lables") ;
        if(data_Labels.includes(brandLabel)){
          let alpha = elem.getAttribute("data-sort") ;
          
          elem.classList.add("showBrand");
          elem.classList.remove("hideBrand");

          document.querySelectorAll('.sortBy_list .alphabetaical_li').forEach(function (ele) {
            alpha == ele.innerHTML.trim() ? ele.classList.add("showAlpha") : ele.classList.add("hideAlpha") ;
          })
          
        }else{
          elem.classList.add("hideBrand");     
          elem.classList.remove("showBrand");
        }
      }); 
  } 
  else {
    console.log('Custom label not found');
  }

  
});

 



var swiper = new Swiper(".brand_images_swiper", {
  slidesPerView:1,
   navigation: {
    nextEl: ".brand_images_next",
    prevEl: ".brand_images_prev",
  }

});




var swiper = new Swiper(".brand-related-swiper", {
  slidesPerView: 4,
  spaceBetween: 20,
   navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
   breakpoints: {

    768: {
      slidesPerView: 4,
    },
    500: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
  },

});



// document.addEventListener("DOMContentLoaded", () => {

//  const urlParams = new URLSearchParams(window.location.search);
//  let brandLabel = "" ;
  
//   if (urlParams.has('custom-label')) {
//       // console.log('Custom label found:',urlParams.get('custom-label'));
//       brandLabel = urlParams.get('custom-label') ;
  
//       document.querySelectorAll(".brands-grid .brands-box").forEach(function (elem) {
  
//         let data_Labels = elem.getAttribute("data-lables") ;
//         if(data_Labels.includes(brandLabel)){
//           let alpha = elem.getAttribute("data-sort") ;
          
//           elem.classList.add("showBrand");
//           elem.classList.remove("hideBrand");

//           document.querySelectorAll('.sortBy_list .alphabetaical_li').forEach(function (ele) {
//             alpha == ele.innerHTML.trim() ? ele.classList.add("showAlpha") : ele.classList.add("hideAlpha") ;
//           })
          
//         }else{
//           elem.classList.add("hideBrand");     
//           elem.classList.remove("showBrand");
//         }
//       }); 
//   } 
//   else {
//     console.log('Custom label not found');
//   }


// });









